import api from '../../services/api';
import type {
  ChatConversation,
  ChatConversationListItem,
  ChatMessage,
  FirebaseTokenResponse,
} from './types';

export async function fetchFirebaseToken(): Promise<FirebaseTokenResponse> {
  const { data } = await api.post<FirebaseTokenResponse>('/chat/firebase-token');
  return data;
}

export async function fetchMyConversation(): Promise<ChatConversation | null> {
  try {
    const { data } = await api.get<ChatConversation>('/chat/conversations/me');
    return data;
  } catch (err: unknown) {
    const status = (err as { response?: { status?: number } })?.response?.status;
    if (status === 404) return null;
    throw err;
  }
}

export interface InboxParams {
  status?: 'open' | 'closed' | 'all';
  q?: string;
  before?: string;
  limit?: number;
}

export async function fetchInbox(params: InboxParams = {}): Promise<ChatConversationListItem[]> {
  const { data } = await api.get<{ items: ChatConversationListItem[] }>(
    '/chat/admin/conversations',
    { params },
  );
  return data.items ?? [];
}

export async function fetchMessages(
  conversationId: string,
  before?: string,
  limit = 50,
): Promise<ChatMessage[]> {
  const { data } = await api.get<{ items: ChatMessage[] }>(
    `/chat/conversations/${conversationId}/messages`,
    { params: { before, limit } },
  );
  return data.items ?? [];
}

export interface SendMessageInput {
  conversationId?: string;
  body: string;
}

export async function sendMessage(input: SendMessageInput): Promise<{ id: string; created_at: string }> {
  const { data } = await api.post<{ id: string; created_at: string }>('/chat/messages', input);
  return data;
}

export async function markConversationRead(conversationId: string): Promise<void> {
  await api.post(`/chat/conversations/${conversationId}/read`);
}

export async function closeConversation(conversationId: string): Promise<void> {
  await api.post(`/chat/admin/conversations/${conversationId}/close`);
}
